/* tslint:disable */
/* eslint-disable */
/**
 * Adgang API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    type AdGroupDetailResponse,
    AdGroupDetailResponseFromJSON,
    AdGroupDetailResponseToJSON,
} from '../models/AdGroupDetailResponse';
import {
    type AdGroupDetailResponsePagedResult,
    AdGroupDetailResponsePagedResultFromJSON,
    AdGroupDetailResponsePagedResultToJSON,
} from '../models/AdGroupDetailResponsePagedResult';
import {
    type AdGroupDetailSearchOrderBy,
    AdGroupDetailSearchOrderByFromJSON,
    AdGroupDetailSearchOrderByToJSON,
} from '../models/AdGroupDetailSearchOrderBy';
import {
    type AdGroupPermissionsUpdateRequest,
    AdGroupPermissionsUpdateRequestFromJSON,
    AdGroupPermissionsUpdateRequestToJSON,
} from '../models/AdGroupPermissionsUpdateRequest';
import {
    type AdGroupRolesUpdateRequest,
    AdGroupRolesUpdateRequestFromJSON,
    AdGroupRolesUpdateRequestToJSON,
} from '../models/AdGroupRolesUpdateRequest';
import {
    type GenericValidationError,
    GenericValidationErrorFromJSON,
    GenericValidationErrorToJSON,
} from '../models/GenericValidationError';
import {
    type NotFoundResult,
    NotFoundResultFromJSON,
    NotFoundResultToJSON,
} from '../models/NotFoundResult';
import {
    type PermissionResponse,
    PermissionResponseFromJSON,
    PermissionResponseToJSON,
} from '../models/PermissionResponse';
import {
    type RoleResponse,
    RoleResponseFromJSON,
    RoleResponseToJSON,
} from '../models/RoleResponse';
import {
    type SortOrder,
    SortOrderFromJSON,
    SortOrderToJSON,
} from '../models/SortOrder';

export interface ApiAdGroupsAdGroupIdGetRequest {
    adGroupId: string;
}

export interface ApiAdGroupsAdGroupIdPermissionsGetRequest {
    adGroupId: string;
}

export interface ApiAdGroupsAdGroupIdPermissionsPutRequest {
    adGroupId: string;
    adGroupPermissionsUpdateRequest: AdGroupPermissionsUpdateRequest;
}

export interface ApiAdGroupsAdGroupIdRolesGetRequest {
    adGroupId: string;
}

export interface ApiAdGroupsAdGroupIdRolesPutRequest {
    adGroupId: string;
    adGroupRolesUpdateRequest: AdGroupRolesUpdateRequest;
}

export interface ApiAdGroupsGetRequest {
    pageNumber?: any;
    pageSize?: any;
    sortOrder?: SortOrder;
    orderField?: AdGroupDetailSearchOrderBy;
    filter?: string;
}

/**
 * 
 */
export class AdGroupsApi extends runtime.BaseAPI {

    /**
     * Creates request options for apiAdGroupsAdGroupIdGet without sending the request
     */
    async apiAdGroupsAdGroupIdGetRequestOpts(requestParameters: ApiAdGroupsAdGroupIdGetRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['adGroupId'] == null) {
            throw new runtime.RequiredError(
                'adGroupId',
                'Required parameter "adGroupId" was null or undefined when calling apiAdGroupsAdGroupIdGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/ad-groups/{adGroupId}`;
        urlPath = urlPath.replace('{adGroupId}', encodeURIComponent(String(requestParameters['adGroupId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async apiAdGroupsAdGroupIdGetRaw(requestParameters: ApiAdGroupsAdGroupIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AdGroupDetailResponse>> {
        const requestOptions = await this.apiAdGroupsAdGroupIdGetRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AdGroupDetailResponseFromJSON(jsonValue));
    }

    /**
     */
    async apiAdGroupsAdGroupIdGet(requestParameters: ApiAdGroupsAdGroupIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AdGroupDetailResponse> {
        const response = await this.apiAdGroupsAdGroupIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for apiAdGroupsAdGroupIdPermissionsGet without sending the request
     */
    async apiAdGroupsAdGroupIdPermissionsGetRequestOpts(requestParameters: ApiAdGroupsAdGroupIdPermissionsGetRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['adGroupId'] == null) {
            throw new runtime.RequiredError(
                'adGroupId',
                'Required parameter "adGroupId" was null or undefined when calling apiAdGroupsAdGroupIdPermissionsGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/ad-groups/{adGroupId}/permissions`;
        urlPath = urlPath.replace('{adGroupId}', encodeURIComponent(String(requestParameters['adGroupId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async apiAdGroupsAdGroupIdPermissionsGetRaw(requestParameters: ApiAdGroupsAdGroupIdPermissionsGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<PermissionResponse>>> {
        const requestOptions = await this.apiAdGroupsAdGroupIdPermissionsGetRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(PermissionResponseFromJSON));
    }

    /**
     */
    async apiAdGroupsAdGroupIdPermissionsGet(requestParameters: ApiAdGroupsAdGroupIdPermissionsGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<PermissionResponse>> {
        const response = await this.apiAdGroupsAdGroupIdPermissionsGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for apiAdGroupsAdGroupIdPermissionsPut without sending the request
     */
    async apiAdGroupsAdGroupIdPermissionsPutRequestOpts(requestParameters: ApiAdGroupsAdGroupIdPermissionsPutRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['adGroupId'] == null) {
            throw new runtime.RequiredError(
                'adGroupId',
                'Required parameter "adGroupId" was null or undefined when calling apiAdGroupsAdGroupIdPermissionsPut().'
            );
        }

        if (requestParameters['adGroupPermissionsUpdateRequest'] == null) {
            throw new runtime.RequiredError(
                'adGroupPermissionsUpdateRequest',
                'Required parameter "adGroupPermissionsUpdateRequest" was null or undefined when calling apiAdGroupsAdGroupIdPermissionsPut().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/ad-groups/{adGroupId}/permissions`;
        urlPath = urlPath.replace('{adGroupId}', encodeURIComponent(String(requestParameters['adGroupId'])));

        return {
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: AdGroupPermissionsUpdateRequestToJSON(requestParameters['adGroupPermissionsUpdateRequest']),
        };
    }

    /**
     */
    async apiAdGroupsAdGroupIdPermissionsPutRaw(requestParameters: ApiAdGroupsAdGroupIdPermissionsPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<any>>> {
        const requestOptions = await this.apiAdGroupsAdGroupIdPermissionsPutRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     */
    async apiAdGroupsAdGroupIdPermissionsPut(requestParameters: ApiAdGroupsAdGroupIdPermissionsPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<any>> {
        const response = await this.apiAdGroupsAdGroupIdPermissionsPutRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for apiAdGroupsAdGroupIdRolesGet without sending the request
     */
    async apiAdGroupsAdGroupIdRolesGetRequestOpts(requestParameters: ApiAdGroupsAdGroupIdRolesGetRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['adGroupId'] == null) {
            throw new runtime.RequiredError(
                'adGroupId',
                'Required parameter "adGroupId" was null or undefined when calling apiAdGroupsAdGroupIdRolesGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/ad-groups/{adGroupId}/roles`;
        urlPath = urlPath.replace('{adGroupId}', encodeURIComponent(String(requestParameters['adGroupId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async apiAdGroupsAdGroupIdRolesGetRaw(requestParameters: ApiAdGroupsAdGroupIdRolesGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<RoleResponse>>> {
        const requestOptions = await this.apiAdGroupsAdGroupIdRolesGetRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(RoleResponseFromJSON));
    }

    /**
     */
    async apiAdGroupsAdGroupIdRolesGet(requestParameters: ApiAdGroupsAdGroupIdRolesGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<RoleResponse>> {
        const response = await this.apiAdGroupsAdGroupIdRolesGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for apiAdGroupsAdGroupIdRolesPut without sending the request
     */
    async apiAdGroupsAdGroupIdRolesPutRequestOpts(requestParameters: ApiAdGroupsAdGroupIdRolesPutRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['adGroupId'] == null) {
            throw new runtime.RequiredError(
                'adGroupId',
                'Required parameter "adGroupId" was null or undefined when calling apiAdGroupsAdGroupIdRolesPut().'
            );
        }

        if (requestParameters['adGroupRolesUpdateRequest'] == null) {
            throw new runtime.RequiredError(
                'adGroupRolesUpdateRequest',
                'Required parameter "adGroupRolesUpdateRequest" was null or undefined when calling apiAdGroupsAdGroupIdRolesPut().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/ad-groups/{adGroupId}/roles`;
        urlPath = urlPath.replace('{adGroupId}', encodeURIComponent(String(requestParameters['adGroupId'])));

        return {
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: AdGroupRolesUpdateRequestToJSON(requestParameters['adGroupRolesUpdateRequest']),
        };
    }

    /**
     */
    async apiAdGroupsAdGroupIdRolesPutRaw(requestParameters: ApiAdGroupsAdGroupIdRolesPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<any>>> {
        const requestOptions = await this.apiAdGroupsAdGroupIdRolesPutRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     */
    async apiAdGroupsAdGroupIdRolesPut(requestParameters: ApiAdGroupsAdGroupIdRolesPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<any>> {
        const response = await this.apiAdGroupsAdGroupIdRolesPutRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for apiAdGroupsGet without sending the request
     */
    async apiAdGroupsGetRequestOpts(requestParameters: ApiAdGroupsGetRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        if (requestParameters['pageNumber'] != null) {
            queryParameters['PageNumber'] = requestParameters['pageNumber'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['PageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['sortOrder'] != null) {
            queryParameters['SortOrder'] = requestParameters['sortOrder'];
        }

        if (requestParameters['orderField'] != null) {
            queryParameters['OrderField'] = requestParameters['orderField'];
        }

        if (requestParameters['filter'] != null) {
            queryParameters['filter'] = requestParameters['filter'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/ad-groups`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async apiAdGroupsGetRaw(requestParameters: ApiAdGroupsGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AdGroupDetailResponsePagedResult>> {
        const requestOptions = await this.apiAdGroupsGetRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AdGroupDetailResponsePagedResultFromJSON(jsonValue));
    }

    /**
     */
    async apiAdGroupsGet(requestParameters: ApiAdGroupsGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AdGroupDetailResponsePagedResult> {
        const response = await this.apiAdGroupsGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
